

// export default EmiDueReport;
import React, { useEffect, useState } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

import "../css/EmiDueReport.css";

const EmiDueReport = () => {
  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  const [emis, setEmis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter, setFilter] = useState("pending"); // default filter

  const baseUrl = "https://narrowitsolution.in/api/loan-emi";

  const apiUrls = {
    pending: `${baseUrl}/overdue?superAdminId=${superAdminId}`,
    today: `${baseUrl}/today?superAdminId=${superAdminId}`,
    upcoming: `${baseUrl}/upcoming7days?superAdminId=${superAdminId}`,
  };

  useEffect(() => {
          const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

    const fetchEmis = async () => {
      setLoading(true);
      try {
        const res = await axios.get(apiUrls[filter]);
        setEmis(res.data.emis || []);
      } catch (err) {
        setError("Failed to fetch EMI due report");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchEmis();
  }, [filter]);

  if (loading) return <div className="EmiDueReport-loading">Loading EMI Report...</div>;
  if (error) return <div className="EmiDueReport-error">{error}</div>;

  // Pagination logic
  const totalPages = Math.ceil(emis.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = emis.slice(startIndex, startIndex + rowsPerPage);

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

  // PDF Export
  const handleDownloadPDF = () => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text("Company EMI Demand Sheet", 14, 20);

  const tableColumn = [
    "#",
    "Customer Name",
    "Loan Number",
    "EMI Number",
    "EMI Amount",
    "Principal",
    "Interest",
    "Outstanding",
    "Due Date",
    "Status"
  ];

  const tableRows = currentData.map((emi, index) => [
    startIndex + index + 1,
    emi.customerName,
    emi.loanNumber,
    emi.emiNumber,
    emi.emiAmount,
    emi.principalComponent,
    emi.interestComponent,
    emi.outstanding,
    new Date(emi.dueDate).toLocaleDateString("en-IN"),
    emi.status
  ]);

  // ✅ Correct way in v3+ / v5+
  autoTable(doc, {
    startY: 30,
    head: [tableColumn],
    body: tableRows,
    theme: "grid",
    headStyles: { fillColor: [99, 102, 241], textColor: 255 },
    styles: { fontSize: 10, cellPadding: 3 }
  });

  doc.save("EMI_Demand_Sheet.pdf");
};

  return (
    <div className="EmiDueReport-wrapper">
      <h1 className="EmiDueReport-title">📋 EMI Due Report</h1>

      {/* Filter buttons */}
      <div className="EmiDueReport-filters">
        {["pending", "today", "upcoming"].map((f) => (
          <button
            key={f}
            className={`filter-btn ${filter === f ? "active" : ""}`}
            onClick={() => {
              setFilter(f);
              setCurrentPage(1);
            }}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      {/* Controls: left rows selector, right PDF download */}
      <div className="EmiDueReport-controls" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>{" "}
          entries
        </label>

        <button className="filter-btn" onClick={handleDownloadPDF}>
          📄 Download PDF
        </button>
      </div>

      <div className="EmiDueReport-table-container">
        <table className="EmiDueReport-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Customer Name</th>
              <th>Loan Number</th>
              <th>EMI Number</th>
              <th>EMI Amount</th>
              <th>Principal</th>
              <th>Interest</th>
              <th>Outstanding</th>
              <th>Due Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length === 0 ? (
              <tr>
                <td colSpan="10" className="EmiDueReport-empty">
                  ✅ No records found
                </td>
              </tr>
            ) : (
              currentData.map((emi, index) => (
                <tr key={emi.id}>
                  <td>{startIndex + index + 1}</td>
                  <td>{emi.customerName}</td>
                  <td>{emi.loanNumber}</td>
                  <td>{emi.emiNumber}</td>
                  <td>₹{emi.emiAmount.toLocaleString()}</td>
                  <td>₹{emi.principalComponent.toLocaleString()}</td>
                  <td>₹{emi.interestComponent.toLocaleString()}</td>
                  <td>₹{emi.outstanding.toLocaleString()}</td>
                  <td>{new Date(emi.dueDate).toLocaleDateString("en-IN")}</td>
                  <td>
                    <span className={`EmiDueReport-status ${emi.status === "pending" ? "pending" : "paid"}`}>
                      {emi.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination controls */}
      <div className="EmiDueReport-pagination">
        <button className="pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>
          ⬅ Prev
        </button>
        <span className="pagination-info">
          Page {currentPage} of {totalPages}
        </span>
        <button className="pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default EmiDueReport;
